<template>
	<b-tr>
		<b-td>
			<b-link @click="showDetails({title:upgrade.Name,content:upgrade.Description})">{{upgrade.Name}}</b-link>
		</b-td>
		<b-td><input type="number" class="form-control form-control-sm" v-if="upgrade.Capacity != ''" v-model.number="charges" /></b-td>
	</b-tr>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	props: [
		'index','upgrade'
	],
	computed: {
		charges: {
			get: function(){
				return this.$store.state.Character.Equipment.Armor[this.$store.state.Character.Current.Armor].Upgrades[this.index].Capacity
			},
			set: function(value) {
				this.setCapacity(value)
			}
		}
	},
	methods: {
		...mapActions('modals', [
			'showDetails',
			'hideDetails'
		]),
		setCapacity: function(value){
			this.$store.commit('setCharacterProp',[
				{
					key: `Equipment.Armor[${this.$store.state.Character.Current.Armor}].Upgrades[${this.index}].Capacity`,
					val: value,
				}
			])
		}
	}
}
</script>

<style scoped>

</style>